<template>
  <div class="action-dialog-header" :class="{ '--square': square }">
    <h5 class="flex items-center q-ma-none ellipsis">
      <q-icon
        v-if="headerIcon.length > 0"
        :name="headerIcon"
        class="q-mr-sm"
        :style="'font-size: ' + headerIconSize"
        :color="headerIconColor"
      />
      <span :class="{ 'q-ml-xs': headerIcon.length > 0 }">{{ header }}</span>
    </h5>

    <q-btn
      round
      dense
      icon="sym_r_close"
      :ripple="false"
      v-close-popup
      class="--icon-button --bordered --shadow__bottom"
      color="background-light"
    />
  </div>
</template>

<script>
export default {
  name: "DialogHeader",
  props: {
    headerIcon: {
      type: String,
      default: ""
    },
    headerIconColor: {
      type: String,
      default: "text"
    },
    headerIconSize: {
      type: String,
      default: "1.5rem"
    },
    header: {
      type: String,
      required: true
    },
    square: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.action-dialog-header {
  background: color(background);
  @include display-flex(row, space-between, center);
  padding: $space-md;
  box-shadow: $shadow-bottom !important;
  flex-wrap: nowrap;
  position: relative;
  z-index: 100;
  border-top-right-radius: 12px !important;
  border-top-left-radius: 12px !important;
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  // border-bottom: 1px solid color(border);

  &.--square {
    border-top-right-radius: 0 !important;
    border-top-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
</style>
